import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { API_URL, WS_URL } from './config';
import { onError } from 'apollo-link-error';
import {
  displaySnackBar,
  SnackVariableInterface,
} from './common/displaySnackbar';
import { ApiErrorCode } from './common/constants';
import { from, split } from 'apollo-boost';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { SubscriptionClient } from 'subscriptions-transport-ws';
const createClient = (token: string) => {
  // Instantiate required constructor fields
  const cache = new InMemoryCache();
  const httpLink = new HttpLink({
    uri: API_URL,
  });
  const wsLink = new WebSocketLink(
    new SubscriptionClient(WS_URL, {
      reconnect: true,
      connectionParams: {
        authToken: token || '',
      },
    }),
  );

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    // const token = localStorage.getItem('token');
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });
  const link = split(
    // split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    authLink.concat(httpLink),
  );
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    const snackBarData: SnackVariableInterface = {
      type: 'ERROR',
      message: 'Erreur',
      isOpen: true,
    };

    const tempClient = new ApolloClient({
      link: authLink.concat(httpLink),
      cache,
    });

    if (graphQLErrors) {
      graphQLErrors.forEach(({ extensions }) => {
        if (extensions && extensions.code) {
          switch (extensions.code) {
            case ApiErrorCode.INTERNAL_SERVER_ERROR:
              snackBarData.message = 'Erreur interne du serveur.';
              break;

            case ApiErrorCode.INVALID_TOKEN:
            case ApiErrorCode.BAD_USER_INPUT:
              snackBarData.message = 'Session expirée.';
              break;
            case ApiErrorCode.UNAUTHENTICATED:
              snackBarData.message =
                'Vous devez vous connecter pour effectuer cette opération.';
              break;

            case ApiErrorCode.USER_NOT_FOUND:
              snackBarData.message = 'Utilisateur introuvable.';
              break;
            case ApiErrorCode.FORBIDDEN:
              snackBarData.message =
                "Accès refusé : votre compte n'est pas autorisé à exécuter cette action";
              break;
          }
        }
      });
    }
    if (networkError) {
      snackBarData.message =
        'Erreur de réseau. Veuillez vérifier votre connexion internet.';
    }

    if (snackBarData.message) displaySnackBar(tempClient, snackBarData);
  });

  return new ApolloClient({
    // Provide required constructor fields
    cache,
    link: from([errorLink, link]),

    // Provide some optional constructor fields
    name: 'react-web-client',
    version: '1.3',
    queryDeduplication: false,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};

export default createClient;
